import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserlaneService {
  public userlaneToggle: Subject<boolean> = new Subject();

  public toggleUserlane(userLaneShown: boolean): void {
    this.userlaneToggle.next(userLaneShown);

    localStorage.setItem('userLaneShown', userLaneShown.toString());
  }

  public userLaneShown(): boolean {
    return JSON.parse(localStorage.getItem('userLaneShown')) as boolean;
  }
}
